import { CalloutComponentType } from "./callout-component-type.js";
const calloutComponentInputTextTypes = [
  CalloutComponentType.INPUT_TEXT_AREA,
  CalloutComponentType.INPUT_TEXT_FIELD
];
export {
  calloutComponentInputTextTypes
};
